const newMapPresenter = require('./eventPresenter/mapPresenter');
const newSignaturePresenter = require('./eventPresenter/signaturePresenter');
const newPackagePresenter = require('./eventPresenter/packagePresenter');
const { clickEventListener, deactivate, formatDateTime, negotiateCssClass, setViewData } = require('gui');
const addressToPlace = require('./addressToPlace');

module.exports = function packageEventPresenter(event) {
    const c = {};
    const view = require('./packageEventPresenter.tpl.html');
    const onClickListener = clickEventListener();
    const mapPresenter = newMapPresenter(event.location);
    const signaturePresenter = newSignaturePresenter(event.signature);
    const deactivator = deactivate();

    c.activate = function(region) {
        event.innerPackages.forEach(function(innerPackage){
            var innerPackagePresenter = newPackagePresenter(innerPackage);
            innerPackagePresenter.activate(view.packagesRegion);
            deactivator.add(innerPackagePresenter);
        });
        view.activate(region);

        negotiateCssClass(view.eventWrapper, 'confirmed', event.isActual);
        negotiateCssClass(view.eventWrapper, 'lastConfirmed', event.lastConfirmed);
        negotiateCssClass(view.showInMap, 'has-location', hasLocation(event.location));
        negotiateCssClass(view.signature, 'has-signature', event.signature);
        negotiateCssClass(view.showInMapButton, 'has-location', hasLocation(event.location));
        negotiateCssClass(view.signatureButton, 'has-signature', event.signature);

        onClickListener.add(view.showInMap, onShowInMap);
        onClickListener.add(view.signature, onShowSignature);
        onClickListener.add(view.showInMapButton, onShowInMap);
        onClickListener.add(view.signatureButton, onShowSignature);
        var viewData = Object.assign({}, event, { place: addressToPlace(event.location) });
        setViewData(view, viewData);
    };

    function hasLocation(location) {
        return location
            && location.latitude
            && location.longitude;
    }

    c.deactivate = function() {
        onClickListener.remove(view.showInMap, onShowInMap);
        onClickListener.remove(view.signature, onShowSignature);
        onClickListener.remove(view.showInMapButton, onShowInMap);
        onClickListener.remove(view.signatureButton, onShowSignature);
        deactivator();
        view.deactivate();
    };

    function onShowInMap() {
        mapPresenter.show(view.showInMap);
    }

    function onShowSignature() {
        signaturePresenter.show(view.signature);
    }

    return c;
};
